module.exports = __webpack_public_path__ + "img/exposure_neg_2.5d0c4a2b.svg";